import request from "@/utils/request";

// 充电卡

// 查询充电卡
export const getNfcCard = params => {
	return request({
		url: "/nfccard",
		method: "GET",
		params,
	});
};

// 保存充电卡
export const setNfcCard = data => {
	return request({
		url: "/nfccard",
		method: "POST",
		data,
	});
};

// 充电卡储值
export const chargeNfcCard = data => {
	return request({
		url: "/nfccard/charge",
		method: "POST",
		data,
	});
};

// 查询充电卡储值历史
export const getNfcCardChargeHistory = params => {
	return request({
		url: "/nfccard/charge/history",
		method: "GET",
		params,
	});
};
